































































/** デコレータ利用のためComponent, Vueをimport **/
import { Component, Vue } from 'vue-property-decorator';
/** 画面で必要なVuexの各stateをimport **/
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';

/** 画面で利用するバックエンド設定のimport **/
import {
  ActionButtons,
  FieldChildrenProp,
  FieldsInfo,
  StatusActions,
  ItemActions,
  StatusList,
  MasterData,
  GetInputFieldsActons,
  HexaFileFieldResponse
} from '@/services/hexabase/types';
import { informationRules } from '@/constants/form/inputCheck';
import { informationEditOptionalForm } from '@/constants/form/informationForm';
import {
  InformationDetailDefine,
  editAuthorityValidMessage,
  editDialogTitle,
  editFinishAction
} from '@/constants/information/information';

/** 画面で利用するモデルファイルをimport **/
import informationModel from '@/models/informationModel';
/** 画面で利用するコンポーネントをimport 下部に存在する＠Componentにも記載する **/
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
import InformationBasicInfoPanel from '@/components/information/detail/InformationBasicInfoPanel.vue';
/** 画面で利用する共通ライブラリをimport **/

interface Rules {
  id: string;
  rule: string[];
  referenceField?: {
    id: string;
    rule: string;
  }[];
}
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    ActionButtonPanel,
    TransitionDialog,
    ExecAction,
    IconTextLink,
    InformationBasicInfoPanel
  }
})

/* eslint-disable @typescript-eslint/camelcase */
export default class InformationEdit extends Vue {
  readonly applicationId = hexabaseState.applicationId;
  readonly employeeId = userState.getUserEmployeeId;
  readonly basicModel = new informationModel();

  // dbID格納プロパティ
  mainDsId = hexabaseState.datastoreIds['お知らせ情報マスタ'];

  // 各入力フィールド情報格納プロパティ
  basicFieldData: Array<FieldChildrenProp> = [];
  basicFieldCols = '';

  // アクション情報格納プロパティ
  statusButton: Array<StatusActions> = [];
  statusAction: Array<StatusActions> = [];
  itemActions: Array<ItemActions> = [];
  execAllowActions: Array<ActionButtons> = [];
  selectAction = '';

  // ステータス情報格納プロパティ
  statusList: Array<StatusList> = [];
  statusRules: { [k: string]: Rules[] } = {};

  // マスタデータ関連格納プロパティ
  masterData: MasterData = {};

  // 登録用情報格納プロパティ
  registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };

  // 編集対象アイテム情報
  itemId = this.$route.params.id;
  revNumber = 0;
  currentData: Array<FieldsInfo> = [];

  // アイテム登録後ダイアログ
  dialogTitle = editDialogTitle;
  dialogStatus = false;
  isLoading = false;
  bodyText = '';
  buttons: Array<{ [k: string]: string | number }> = editFinishAction;

  // コンポーネントで使用するタイトル等
  execActionMessage = editAuthorityValidMessage;

  // 利用しないステータス項目を定義する
  // ※削除実行後に削除済データの表示を行うため、利用しないステータスは無し
  readonly notSearchStatusId = [];

  // 対象アイテムの現ステータス（日本語名）
  displayStatus = '';
  // 対象アイテムの現ステータスID
  statusId = '';

  async created() {
    try {
      // ローディングをセット
      hexabaseState.setIsLoading(true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.basicModel.getDefaultRoleErrorMessage());
        return;
      }

      // 既存アイテムを取得しアイテム情報・アクション情報を保持
      const basicResult = await this.basicModel.getCurrentItem(
        this.applicationId,
        this.mainDsId,
        this.itemId,
        this.notSearchStatusId
      );

      // アイテム詳細APIの結果から紐づくステータスアクションを取得
      if (this.basicModel.isNullOrUndefined(basicResult.status_actions))
        basicResult.status_actions.forEach(v => this.statusAction.push(v));

      // アイテム詳細APIの結果から紐づくアイテムアクションを取得
      if (this.basicModel.isNullOrUndefined(basicResult.item_actions))
        basicResult.item_actions.forEach(v => this.itemActions.push(v));

      // アイテム詳細APIの結果から紐づくステータスリストを取得
      if (this.basicModel.isNullOrUndefined(basicResult.status_list))
        basicResult.status_list.forEach(v => this.statusList.push(v));

      // ステータス用の変数へ値をセットする
      if (this.statusList.length > 0) {
        const statusValue = basicResult.field_values.find(v => v.dataType === 'status')?.value;
        if (statusValue === undefined) return;
        const currentStatus = this.statusList.find(v => v.status_id === statusValue);
        this.statusId = currentStatus?.display_id !== undefined ? currentStatus.display_id : '';
        // 「有効」の場合はステータスを表示しない
        this.displayStatus =
          currentStatus?.status_name === '有効' ? '' : currentStatus?.status_name || '';
      }

      // リビジョン番号を格納
      this.revNumber = basicResult.rev_no;
      // 登録用情報データを作成（更新前初期値）
      this.currentData = basicResult.field_values;
      for (const key in this.currentData) {
        if (this.currentData[key].value !== undefined && this.currentData[key].value !== null) {
          let value = this.currentData[key].value;
          if (
            this.currentData[key].dataType === 'dslookup' &&
            typeof this.currentData[key].value === 'object' &&
            this.currentData[key].value !== null &&
            this.currentData[key].value.item_id !== undefined
          ) {
            value = this.currentData[key].value.item_id;
          }
          if (this.currentData[key].dataType === 'file') {
            value =
              this.currentData[key].value.length === 0
                ? []
                : (this.currentData[key].value as HexaFileFieldResponse[])
                    .map(file => file.file_id)
                    .filter(v => v);
          }
          this.registData.item[this.currentData[key].field_id] = value;
        }
      }

      // 実行可能なアクションを取得
      this.execAllowActions = this.basicModel.getExecAllowAction(
        this.statusAction,
        this.itemActions,
        this.statusId
      );

      this.getBasicFields();

      // 画面上部に表示するボタン設定
      // ユーザ毎の制御や特殊なパターンは別途関数を用意してフィルターする
      this.statusButton = this.execAllowActions;
    } catch (e) {
      this.setError(e as string | object);
    } finally {
      hexabaseState.setIsLoading(false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形
   */
  async getBasicFields() {
    try {
      const initialAction = this.basicModel.getFormDisplayAction(
        this.itemActions,
        InformationDetailDefine.edit.initialActionId
      );
      const [inputFields, fieldsData] = await Promise.all([
        this.basicModel.getFieldsByActionId(this.mainDsId, initialAction!.action_id),
        this.basicModel.makeFieldsList(this.applicationId, this.mainDsId, this.currentData)
      ]);
      const data = this.basicModel
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.basicModel.deepCopy(informationEditOptionalForm)
        )
        .map(field => this.basicModel.inputRestriction(field, inputFields))
        .map(field => this.basicModel.setSelectAreaItemId(field))
        .map(field => this.basicModel.setPropsByLocalProperty(field, this))
        .map(field => {
          if (field.dataType === 'dslookup') {
            field.props!.isBtnVisible = false;
          }
          field.props!.isReadonly = true;
          field.props!.isDisabled = true;
          if (field.dataType === 'textarea') {
            // 複数行テキストの場合はReadonlyのみにする
            field.props!.isDisabled = false;
          }
          return field;
        });

      this.basicFieldCols = this.basicModel.getGridStatus(data);
      this.basicFieldData = data;
    } catch (e) {
      this.setError(e as string | object);
    }
  }

  /**
   * 初回アクセス時の入力制限
   */
  addInputProhibited(data: FieldChildrenProp[], options?: Array<string>): FieldChildrenProp[] {
    return data.map(field => {
      if (field.props === undefined) return field;
      if (options !== undefined && options.length > 0) {
        // 指定された項目の入力制限は行わない
        if (options.filter(option => field.display_id === option).length > 0) {
          return field;
        }
      }
      if (field.dataType === 'dslookup') {
        field.props!.isBtnVisible = false;
      }
      if (field.component === 'MasterSelectControl') {
        field.props!.isLeftSideInputReadOnly = true;
      }
      field.props!.isReadonly = true;
      field.props!.isDisabled = true;
      return field;
    });
  }

  /**
   * 子コンポーネントからEmitされる値を更新用に加工
   * @module catchInput
   * @param response - 子コンポーネントより渡される値
   */
  catchInput(response: any) {
    const index = this.basicFieldData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldData[index].props!, 'value', response.value);
    }

    // 入力値から登録データを生成
    const name = response.name;
    const value = response.value;
    this.registData.item[name] = value;
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta?.breadcrumbs;
    }
    return [];
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param type - イベント情報として押下したボタン種類が返ってくる
   */
  async buttonAction(type: string) {
    try {
      // 全要素ReadOnlyアクションか判定（削除アクションか判定）
      const isReadOnly = type === InformationDetailDefine.edit.deleteActionId;

      // ローディングをセット
      hexabaseState.setIsLoading(true);

      // アクション毎の見出し要素入力制限反映
      const copy = this.basicModel.modifyButtonProp(this.execAllowActions, type);
      if (copy !== undefined && copy.length > 0) {
        this.execAllowActions.splice(0, copy.length, ...copy);
      }

      // 見出し側のアクション設定
      const execAction = this.execAllowActions.find(action => action.display_id === type);

      // 選択したアクションのアクションID
      this.selectAction = execAction!.display_id;

      // 見出しの指定されたアクションに紐づくフィールド情報を取得する
      const inputFields = await this.basicModel.getFieldsByActionId(
        this.mainDsId,
        execAction!.action_id
      );

      // 取得したアクションに紐づく情報から基本情報部のフィールドを整形する
      const result = this.modifyFields(this.basicFieldData, inputFields, type);
      this.basicFieldData = isReadOnly ? this.addInputProhibited(result) : result;

      // 入力に紐付け入力チェックがある場合
      if (this.statusRules !== undefined && this.statusRules[this.selectAction] !== undefined) {
        const validateRules = this.basicModel.addLinkingRuleByInitial(
          this.statusRules[this.selectAction],
          this.registData.item,
          this.basicFieldData
        );
        if (validateRules.length > 0) {
          for (const ruleIndex in validateRules) {
            this.$set(
              this.basicFieldData[validateRules[ruleIndex].key].props!,
              'rules',
              validateRules[ruleIndex].rules
            );
          }
        }
      }
    } catch (e) {
      this.setError(e as string | object);
    } finally {
      hexabaseState.setIsLoading(false);
    }
  }

  /**
   * フィールド整形用関数をまとめた関数
   * @param data - テーブルが持つフィールドデータ
   * @param inputFields - テーブルアクションに対応するフィールドデータ
   * @param type - 押下したボタンのアクションID
   * @returns modifyInputAllow(data, inputFields.action_field_settings)
   */
  modifyFields(data: Array<FieldChildrenProp>, inputFields: GetInputFieldsActons, type: string) {
    data = this.basicModel.addInputRules(
      data,
      inputFields.action_field_settings,
      type,
      informationRules.information_edit
    );
    return this.basicModel.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  /**
   * 画面下部ボタンを押下した際に実行される処理
   * @param type - 実行、キャンセルボタンを判別する文字列を受け取る
   */
  async execAction(type: string) {
    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        try {
          // ローディングをセット
          hexabaseState.setIsLoading(true);
          this.bodyText = '';

          const response = await this.basicModel.execStatusAction(
            this.registData,
            this.applicationId,
            this.mainDsId,
            this.itemId,
            this.execAllowActions,
            this.revNumber,
            this.selectAction
          );

          if (response !== undefined && response.text !== undefined && response.text.length > 0) {
            this.bodyText = response.text;
          }
        } catch (e) {
          this.setError(e as string | object);
        } finally {
          hexabaseState.setIsLoading(false);
          this.dialogStatus = true;
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   */
  editFinish() {
    this.dialogStatus = false;
    this.isLoading = false;
    this.selectAction = '';
  }

  /**
   * 前画面へ遷移する
   */
  handleScreenBack() {
    this.$router.back();
  }

  /**
   * API実行結果から受け取ったエラーメッセージを共通のエラーダイアログに表示する
   * @param errorMessage - API実行結果から受け取ったエラーメッセージ
   * @returns {void}
   */
  setError(errorMessage: string | object): void {
    if (typeof errorMessage === 'object') errorMessage = this.basicModel.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
